const paymentProcessingComponentLoaders = Object.freeze({
  'payment-processing.gateway-workspace': async () => {
    const module = await import('./payment-gateway-workspace-component.js');
    return module.PaymentGatewayWorkspaceComponent;
  },
  'payment-processing.workspace': async () => {
    const module = await import('./payment-workspace-component.js');
    return module.PaymentWorkspaceComponent;
  },
});

export default paymentProcessingComponentLoaders;
